
export default function CaseSection() {
  const cases = [
    {
      title: '混批拼柜 → 海外批发商补货',
      type: '批发商',
      solution: '多品类混批 + 拼柜发货',
      delivery: '整柜/拼柜灵活组合',
      result: '降低30%物流成本，补货周期缩短至15天',
      image: 'https://public.readdy.ai/ai/img_res/7f20e5f66472adbbef53c4cb64977837.jpg'
    },
    {
      title: '平台卖家小单试单 → 资料包齐全快速上架',
      type: '平台卖家',
      solution: '小批量定制 + 标准化资料包',
      delivery: '产品图/参数/认证文件一站式',
      result: '上架时间从7天缩短至2天，转化率提升45%',
      image: 'https://readdy.ai/api/search-image?query=E-commerce%20seller%20workspace%20with%20product%20photography%20setup%2C%20professional%20product%20documentation%20and%20certification%20files%2C%20laptop%20showing%20online%20store%20platform%2C%20organized%20product%20samples%2C%20modern%20office%20environment%2C%20clean%20business%20photography%2C%20bright%20natural%20lighting&width=600&height=400&seq=case-002&orientation=landscape'
    },
    {
      title: '铝天花系统 → 一套配齐出海交付',
      type: '工程单',
      solution: '铝扣板+龙骨+配件系统化供应',
      delivery: '技术支持 + 安装指导 + 合规文件',
      result: '整体方案交付，客户满意度98%，复购率70%',
      image: 'https://readdy.ai/api/search-image?query=Aluminum%20ceiling%20system%20installation%20in%20modern%20commercial%20building%2C%20complete%20ceiling%20panels%20and%20accessories%20kit%2C%20professional%20construction%20site%2C%20technical%20documentation%20and%20installation%20guides%2C%20high-quality%20building%20materials%2C%20realistic%20architectural%20photography&width=600&height=400&seq=case-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">产业带联动案例</h2>
          <p className="text-lg text-gray-500">批发 / 平台卖家真实成功案例</p>
        </div>

        <div className="grid grid-cols-3 gap-6">
          {cases.map((caseItem, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all group cursor-pointer"
            >
              <div className="relative h-56 w-full overflow-hidden">
                <img
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-[#8B1A1A] text-white rounded-full text-sm font-semibold">
                    {caseItem.type}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-900 mb-4 leading-tight">
                  {caseItem.title}
                </h3>

                <div className="space-y-3 mb-5">
                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center bg-[#8B1A1A]/10 rounded mt-0.5 shrink-0">
                      <i className="ri-lightbulb-line text-xs text-[#8B1A1A]"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">组合方案</div>
                      <div className="text-sm text-gray-700 font-medium">{caseItem.solution}</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center bg-[#C9A84C]/15 rounded mt-0.5 shrink-0">
                      <i className="ri-truck-line text-xs text-[#C9A84C]"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">交付方式</div>
                      <div className="text-sm text-gray-700 font-medium">{caseItem.delivery}</div>
                    </div>
                  </div>

                  <div className="flex items-start gap-2">
                    <div className="w-5 h-5 flex items-center justify-center bg-[#C9A84C]/15 rounded mt-0.5 shrink-0">
                      <i className="ri-trophy-line text-xs text-[#C9A84C]"></i>
                    </div>
                    <div>
                      <div className="text-xs text-gray-400 mb-0.5">结果</div>
                      <div className="text-sm text-gray-700 font-medium">{caseItem.result}</div>
                    </div>
                  </div>
                </div>

                <button className="w-full px-4 py-2.5 border-2 border-gray-200 text-gray-600 rounded-xl font-medium hover:border-[#8B1A1A] hover:text-[#8B1A1A] hover:-translate-y-0.5 transition-all cursor-pointer whitespace-nowrap text-sm">
                  查看完整案例
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
